// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rb-main {
  margin: 3%;
}

.tabs-container {
  display: flex;
  justify-content: flex-start;
  margin: 1rem 0;
}

.tab {
  background: none;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s ease, color 0.3s ease;
}

.tab:hover {
  color: #007bff;
}

.tab.active {
  font-weight: bold;
  color: #007bff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reimbursement/RbTeamLead.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".rb-main {\n  margin: 3%;\n}\n\n.tabs-container {\n  display: flex;\n  justify-content: flex-start;\n  margin: 1rem 0;\n}\n\n.tab {\n  background: none;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.3s ease, color 0.3s ease;\n}\n\n.tab:hover {\n  color: #007bff;\n}\n\n.tab.active {\n  font-weight: bold;\n  color: #007bff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
